export const JobStatus = {
  READY: 'READY',
  FINISHED: 'FINISHED',
  ABORT: 'ABORT',
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
};

export function getJobIconByStatus(jobStatus) {
  if (jobStatus === JobStatus.READY) {
    return 'fa fa-circle-o';
  } else if (jobStatus === JobStatus.FINISHED) {
    return 'fa fa-circle';
  } else if (jobStatus === JobStatus.ABORT) {
    return 'fa fa-circle';
  } else if (jobStatus === JobStatus.ERROR) {
    return 'fa fa-circle';
  } else if (jobStatus === JobStatus.PENDING) {
    return 'fa fa-circle';
  } else if (jobStatus === JobStatus.RUNNING) {
    return 'fa fa-spinner';
  }
}

export function getJobColorByStatus(jobStatus) {
  if (jobStatus === JobStatus.READY) {
    return 'green';
  } else if (jobStatus === JobStatus.FINISHED) {
    return 'green';
  } else if (jobStatus === JobStatus.ABORT) {
    return 'orange';
  } else if (jobStatus === JobStatus.ERROR) {
    return 'red';
  } else if (jobStatus === JobStatus.PENDING) {
    return 'gray';
  } else if (jobStatus === JobStatus.RUNNING) {
    return 'blue';
  }
}
